import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import { appName } from "../../../../app.json";
import NewRisk from "./NewRisk";
import PatientRiskList from "./RiskList";
import Pagination from "../../../../partials/pagination";
import LoadingSpinner from "../../../../partials/loading";
import AlertMessage from "../../../../partials/alertMessage";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { LIST, CREATE } from "../../../../queries/patient-risk.query";
import auth from "../../../../providers/Auth.Provider";
import { ReadData } from "../../../../providers/Patient.Provider";

function PatientRisk({ location }) {
    // local state
    const [page, setPage] = useState(1);
    const [limit] = useState(25);

    const patient = ReadData();
    const ref = patient.id;
    // get list
    const { loading, data, error, fetchMore } = useQuery(LIST, {
        variables: {
            patient: ref,
            page,
            limit,
        },
    });
    // new risk
    const [newFunc, { loading: cLoading, data: cData, error: cError }] = useMutation(CREATE, {
        update(caches, cb) {
            const { GetPatientRisks } = caches.readQuery({
                query: LIST,
                variables: {
                    patient: ref,
                    page,
                    limit,
                },
            });
            GetPatientRisks.docs.unshift(cb.data.RecordNewPatientRisk.doc);
            GetPatientRisks.totalDocs++;
            caches.writeQuery({
                query: LIST,
                data: { GetPatientRisks },
                variables: {
                    patient: ref,
                    page,
                    limit,
                },
            });
        },
    });

    const title = "Patient Risk";

    if (error && auth.authProvider.IsAuthenticationError(error.message)) {
        // clear session
        auth.authProvider.LogOut();
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    search: `?redirect=${location.pathname}`,
                    state: { from: { pathname: location.pathname } },
                }}
            />
        );
    }
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="card">
                        <div className="card-head">
                            <header>{title}</header>
                        </div>
                        <div className="card-body m-b-20 height-min">
                            <LoadingSpinner loading={loading || cLoading} />
                            <AlertMessage message={(error && error.message) || (cError && cError.message)} failed={true} />
                            <AlertMessage message={cData && cData.RecordNewPatientRisk.message} />

                            <NewRisk
                                onSubmit={async (name) => {
                                    await newFunc({
                                        variables: {
                                            model: { patient: ref, risk: name },
                                        },
                                    });
                                }}
                            />
                            <hr />
                            <PatientRiskList items={data && data.GetPatientRisks.docs} />
                        </div>
                        <div className="card-footer">
                            {data && (
                                <Pagination
                                    {...data.GetPatientRisks}
                                    length={data.GetPatientRisks.docs.length}
                                    onPageClicked={(page) => {
                                        setPage(page);
                                        fetchMore({
                                            variables: { page },
                                            updateQuery: (prev, { fetchMoreResult }) => {
                                                if (prev) return prev;
                                                return {
                                                    GetPatientRisks: fetchMoreResult.GetPatientRisks,
                                                };
                                            },
                                        });
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PatientRisk;
